export default ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
